export const SET_GLS_PAGE_PK = "GLS_PAGE_PK::SET";
export const SET_GLS_PAGE_NAME = "GLS_PAGE_NAME::SET";
export const SET_CMS_VERSION = "CMS_VERSION::SET";
export const SET_APP_VERSION = "APP_VERSION::SET";
export const SET_AVAILABLE_PAGE_VERSIONS = "AVAILABLE_PAGE_VERSIONS::SET";
export const SET_GLS_PAGE_REVISION_PK = "GLS_PAGE_REVISION_PK::SET";
export const SET_SHOW_GLS_ADMIN = "SHOW_GLS_ADMIN::SET";
export const SET_SHOW_ADMIN_TOOLBAR = "SHOW_ADMIN_TOOLBAR::SET";
export const SET_EDITABLE_MODE = "EDITABLE_MODE::SET";

export const SET_COMPONENT_TREE = "COMPONENT_TREE::SET";
export const SET_TYPE_COMPONENT_CATEGORIES = "TYPE_COMPONENT_CATEGORIES::SET";
export const SET_ACTUAL_VERSION = "ACTUAL_VERSION::SET";
